export const validateFormJson = (data: any): boolean => {
  if (Object.keys(data).length === 0) {
    return false
  }
  if(!data.type || !data.properties || !data.id || !data.elementId) {
    return false;
  }
  return true;
}